import { useRouter, LoginForm, Link, useStore } from '@/core'
import { legacyRoute } from '@u/legacy-route'
import { fetchUserInfo } from '@u/drf/auth'
import { useTranslation } from 'react-i18next'
import authStyles from '@c/auth-layout/style.module.less'

export const LoginWithEmailPage = ({}) => {
  const { t, i18n } = useTranslation()
  const router = useRouter()
  const store = useStore()
  const [language, setLanguage] = store.use(['language'])
  const [next] = store.use(['next'])
  return (
    <>
      <div className={authStyles.formHeader}>
        <h1>{t('auth.loginWithEmailPage.title')}</h1>
        <p>Login to your account.</p>
      </div>
      <LoginForm
        onSuccess={(info) => {
          const preferredLanguage = info?.profile?.preferredLanguage || 'en'
          setLanguage(preferredLanguage)
          i18n.changeLanguage(preferredLanguage)
          if (next.route) {
            router.push(next.route)
          } else if (next.string) {
            legacyRoute(next.string)
          } else if (info.legacyNextUrl) {
            legacyRoute(info.legacyNextUrl)
          } else if (info.nextUrl) {
            router.push({ name: info.nextUrl })
          } else if (info.legacyHomeUrl) {
            legacyRoute(info.legacyHomeUrl)
          } else {
            router.push({ name: info.homeUrlName })
          }
        }}
        fetchUserInfo={fetchUserInfo}
      />
      <div style={{ marginTop: '1.5rem', textAlign: 'center', display: 'flex', flexDirection: 'column', gap: '8px' }}>
        <p style={{ fontSize: '14px' }}>
          <Link name="forgotPassword" style={{ color: '#2B9FE8' }}>
            {t('auth.loginWithEmailPage.forgot_password')}
          </Link>
        </p>
        <p style={{ fontSize: '14px', color: '#6B7B8D' }}>
          {t('auth.loginWithEmailPage.no_account')}{' '}
          <Link name="signup" style={{ color: '#2B9FE8', fontWeight: 600 }}>
            {t('auth.loginWithEmailPage.signup_link')}
          </Link>
        </p>
        <p style={{ fontSize: '14px' }}>
          <Link name="nonprofitLogin" style={{ color: '#2B9FE8' }}>
            {t('auth.loginWithEmailPage.nonprofit_login_link')}
          </Link>
        </p>
      </div>
    </>
  )
}
